import { Component, OnInit } from '@angular/core';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
  selector: 'app-game-menu',
  templateUrl: './game-menu.component.html',
  styleUrls: ['./game-menu.component.css']
})
export class GameMenuComponent implements OnInit {

  constructor(
    private mixpanel: MixpanelService,
    private jwt: JwtService
  ) { }

  ngOnInit(): void {
    this.mixpanel.track("page_view", { page: "Menu", category: "Games", button: "-"  });
    this.jwt.check();
  }

}
